import { useBlitzStore } from '../stores/BlitzStore'

function decodeJwt (token) {
  const base64Payload = token.split('.')[1]
  const payload = decodeURIComponent(
    atob(base64Payload)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(payload)
}

function guest (to, from, next) {
  const store = useBlitzStore()

  if (!store.token) {
    next()
  } else {
    next('/')
  }
}

function auth (to, from, next) {
  const store = useBlitzStore()
  const payload = store.token ? decodeJwt(store.token) : null
  const expired = store.token ? Date.now() >= (payload.exp * 1000) : null

  if (!!store.user && !!store.token && !expired) {
    next()
  } else {
    store.logout()
    next('/login')
  }
}

function deny (...roles) {
  return (to, from, next) => {
    const store = useBlitzStore()
    roles.includes(store.user?.type) ? next('/') : next()
  }
}

export {
  guest,
  auth,
  deny
}
